export const UI_NAME = 'ui-tabs';
